import { Component, OnInit } from '@angular/core';
import { HeaderStateService } from '../main/headers/services/header-state.service';
import { TranslocoService } from '@jsverse/transloco';
import { KnowHowService } from './services/know-how.service';
import { SharedToasterService } from '../shared/services/shared-toaster.service';
import { KnowHowDocumentsDocumentModel } from './models/documents/know-how-documents-document.model';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DocumentLinkDisplayModalComponent } from '../document-links/components/document-link-display-modal/document-link-display-modal.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-know-how',
    templateUrl: './know-how.component.html',
    styleUrl: './know-how.component.scss'
})
export class KnowHowComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private headerStateService: HeaderStateService,
        private translocoService: TranslocoService,
        private knowHowService: KnowHowService,
        private sharedToasterService: SharedToasterService,
        private bsModalService: BsModalService
    ) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.knowHowTitle'),
            this.translocoService.translate('main.header.knowHowDescription'))
    }

    ngOnInit(): void {
        let documentId = this.route.snapshot.queryParams['documentId'];
        if (documentId == null) return;
        this.openDocument(documentId);
    }

    private openDocument(documentId: string) {
        this.knowHowService.getDocumentDetailsById(documentId).subscribe({
            next: (document: KnowHowDocumentsDocumentModel) => {
                this.openDocumentModal(document);
            },
            error: () => {
                this.sharedToasterService.showGeneralDataLoadingError();
            }
        });
    }

    protected openDocumentModal(document: KnowHowDocumentsDocumentModel): void {
        if (document.documentId == null) return;
        if (document.name == null) return;
        if (document.type == null) return;

        this.bsModalService.show(DocumentLinkDisplayModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                name: document.name,
                documentId: document.documentId,
                linkUrl: document.linkUrl,
                type: document.type,
                acceptanceDeadlineUtc: document.acceptanceDeadlineUtc,
                isReadByUser: document.isReadByUser,
            }
        });
    }

}

